class pdpSoldoutUpsell extends HTMLElement {
  constructor() {
    super();
    this.DELAY_MS = 3000;
    this.overlay = null;
    this._boundOnOverlayClick = this.onOverlayClick.bind(this);
    this._boundOnKeydown = this.onKeydown.bind(this);
  }

  connectedCallback() {
    this.overlay = this.querySelector('#pdp-sold-out-modal-overlay');
    if (!this.overlay) return;

    // Show modal after 3 seconds
    this.showTimeout = setTimeout(() => {
      this.showModal();
    }, this.DELAY_MS);

    // Bind events
    this.overlay.addEventListener('click', this._boundOnOverlayClick);
    document.addEventListener('keydown', this._boundOnKeydown);

    // Close button
    const closeBtn = this.querySelector('.sold-out-modal__close');
    if (closeBtn) {
      closeBtn.addEventListener('click', () => this.closeModal());
    }
  }

  disconnectedCallback() {
    clearTimeout(this.showTimeout);
    if (this.overlay) {
      this.overlay.removeEventListener('click', this._boundOnOverlayClick);
    }
    document.removeEventListener('keydown', this._boundOnKeydown);
  }

  showModal() {
    if (!this.overlay) return;
    this.overlay.style.display = 'flex';
    // Force reflow so the transition triggers
    void this.overlay.offsetWidth;
    this.overlay.classList.add('is-visible');
    document.body.style.overflow = 'hidden';

    // Initialize Slick slider after modal is visible
    this.initSlider();
  }

  closeModal() {
    if (!this.overlay) return;
    this.overlay.classList.remove('is-visible');
    document.body.style.overflow = '';

    // Wait for transition to finish, then hide
    setTimeout(() => {
      this.overlay.style.display = 'none';
    }, 300);
  }

  onOverlayClick(e) {
    if (e.target === this.overlay) {
      this.closeModal();
    }
  }

  onKeydown(e) {
    if (e.key === 'Escape' && this.overlay && this.overlay.classList.contains('is-visible')) {
      this.closeModal();
    }
  }

  initSlider() {
    const $slider = $(this).find('.sold-out-modal__slider');
    if ($slider.length === 0 || $slider.hasClass('slick-initialized')) return;

    $slider.slick({
      infinite: false,
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: false,
      arrows: true,
      dots: false,
      centerMode: false,
      accessibility: false,
      prevArrow:
        '<button type="button" class="slick-prev sold-out-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="16" viewBox="0 0 14 16" fill="none"><path d="M14 7.1502H3.26502L9.23553 1.20161L8.02949 0L0 8L8.02949 16L9.23553 14.7984L3.26502 8.8498H14V7.1502Z" fill="black"/></svg></button>',
      nextArrow:
        '<button type="button" class="slick-next sold-out-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="16" viewBox="0 0 14 16" fill="none" style="transform:scaleX(-1)"><path d="M14 7.1502H3.26502L9.23553 1.20161L8.02949 0L0 8L8.02949 16L9.23553 14.7984L3.26502 8.8498H14V7.1502Z" fill="black"/></svg></button>',
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 1.5,
            arrows: true,
          },
        },
      ],
    });
  }
}

customElements.define('pdp-soldout-upsell', pdpSoldoutUpsell);